import axios from 'axios';
import authHeader from './admin-auth-header';

const API_URL = '/admin/';

/**
 * Service class for handling administrative operations.
 */
class AdminService {

    async deleteInscription(id_inscription) {
        if (!id_inscription) return false;
        try {
            await axios.get(API_URL + 'inscription/delete.php?id_inscription=' + id_inscription, { headers: authHeader() });
            return true;
        }
        catch (err) {
            return false;
        }
    }

    async deletePreInscription(id_commande) {
        if (!id_commande) return false;
        try {
            await axios.get(API_URL + 'pre_inscription/delete.php?id_commande=' + id_commande, { headers: authHeader() });
            return true;
        }

        catch (err) {
            return false;
        }
    }

    /* Une inscription */
    async getInscription(id_inscription) {
        if (!id_inscription) return false;
        try {
            let res = await axios.get(API_URL + 'inscription/get.php?id_inscription=' + id_inscription, { headers: authHeader() });
            return res.data;
        }
        catch (err) {
            return false;
        }
    }

    async getCourses(id_module, mode = "", has_preinscriptions = false) {
        if (has_preinscriptions) {
            mode += "&has_preinscriptions=1";
        }
        if (!id_module) return false;
        try {
            let res = await axios.get(API_URL + 'courses/get.php?id_module=' + id_module + '&mode=' + mode, { headers: authHeader() });
            return res.data;
        }
        catch (err) {
            return false;
        }
    }

    async getPointageAccueil(id_module) {
        if (!id_module) return false;
        try {
            let res = await axios.get(API_URL + 'pointage_accueil/get.php?id_module=' + id_module, { headers: authHeader() });
            return res.data;
        }
        catch (err) {
            return false;
        }
    }

    /* Récupere la liste des demandes de transfert liées à une inscription */
    async getTransfertInscriptionRequests(id_inscription) {
        if (!id_inscription) return [];
        try {
            let res = await axios.get(API_URL + 'inscription/transferts/get.php?id_inscription=' + id_inscription, { headers: authHeader() });
            return res.data;
        }
        catch (err) {
            return [];
        }
    }

    /**
     * Get a list of all users authorized to access a module.
     * @param {*} id_module 
     * @returns [] | false
     */
    async getAuthorizedUsers(id_module) {
        if (!id_module) return false;
        try {
            let res = await axios.get(API_URL + 'authorized_users/get.php?id_module=' + id_module, { headers: authHeader() });
            return res.data;
        }
        catch (err) {
            return false;
        }
    }

    async getModulePaymentsRequests(id_module) {
        if (!id_module) return false;
        try {
            let res = await axios.get(API_URL + 'module/payments_requests/get.php?id_module=' + id_module, { headers: authHeader() });
            return res.data;
        }
        catch (err) {
            return [];
        }
    }

    /**
     * Create a new admin user for a module
     * @param {*} user 
     * @returns 
     */
    async registerAuthorizedUser(user) {
        try {
            let res = await axios.post(API_URL + 'authorized_user/post.php', user, { headers: authHeader() });
            return res.data;
        }
        catch (err) {
            return err.response.data;
        }
    }

    /**
     * Fetch list of inscriptions to XGTV for validation
     * @returns [] | false
     */
    async getXGTVInscritsForValidation() {
        try {
            let res = await axios.get(API_URL + 'verification_documents_XGTV/inscrits/get.php', { headers: authHeader() });
            return res.data;
        }
        catch (err) {
            return false;
        }
    }

    async getListInscritsMultiParcours(id_module) {
        if (!id_module) return false;
        try {
            let res = await axios.get(API_URL + 'inscriptions/multi_parcours/get.php?id_module=' + id_module, { headers: authHeader() });
            return res.data;
        }
        catch (err) {
            return false;
        }
    }


    async validateXGTVDocument(id_inscription, privilege) {
        try {
            await axios.post(API_URL + 'verification_documents_XGTV/post.php', { id_inscription: id_inscription, privilege: privilege }, { headers: authHeader() });
            return true;
        }
        catch (err) {
            return false;
        }
    }

    async postCommande(booking) {
        if (!booking) return false;
        try {
            let res = await axios.post(API_URL + 'commande/post.php', booking, { headers: authHeader() });
            return res.data;
        }
        catch (err) {
            return false;
        }
    }

    /* Envoi la demande de transfert d'une inscription */
    async sendTransfertRequest(request) {
        if (!request) return false;
        try {
            await axios.post(API_URL + 'inscription/transfert/post.php', request, { headers: authHeader() });
            return true;
        }
        catch (err) {
            return err.response.data;
        }
    }

    async updateEventConfig(event) {
        if (!event) return false;
        try {
            await axios.post(API_URL + 'evenement/update_config.php', event, { headers: authHeader() });
            return true;
        }
        catch (err) {
            return err.response.data;
        }
    }

    async updateModuleConfig(module) {
        if (!module) return false;
        try {
            await axios.post(API_URL + 'module/update_config.php', module, { headers: authHeader() });
            return true;
        }
        catch (err) {
            return err.response.data;
        }
    }

    async updateCoursesConfig(courses) {
        if (!courses) return false;
        try {
            await axios.post(API_URL + 'courses/update_config.php', courses, { headers: authHeader() });
            return true;
        }
        catch (err) {
            return err.response.data;
        }
    }

    async getOptions(id_module, has_preinscriptions = false) {
        if (!id_module) return false;
        try {
            let url = API_URL + 'options/get.php?id_module=' + id_module;
            if (has_preinscriptions) url += '&has_preinscriptions=1';
            let res = await axios.get(url, { headers: authHeader() });
            return res.data;
        }
        catch (err) {
            return false;
        }
    }

    async updateOptionsConfig(options) {
        if (!options) return false;
        try {
            await axios.post(API_URL + 'options/update_config.php', options, { headers: authHeader() });
            return true;
        }
        catch (err) {
            return err.response?.data;
        }
    }

    async getActivites(id_module) {
        if (!id_module) return false;
        try {
            let res = await axios.get(API_URL + 'activites/get.php?id_module=' + id_module, { headers: authHeader() });
            return res.data;
        }
        catch (err) {
            return false;
        }
    }

    async updateActivitesConfig(activites) {
        if (!activites) return false;
        try {
            await axios.post(API_URL + 'activites/update_config.php', activites, { headers: authHeader() });
            return true;
        }
        catch (err) {
            return err.response?.data;
        }
    }

    async getArticlesBoutique(id_module) {
        if (!id_module) return false;
        try {
            let res = await axios.get(API_URL + 'articles_boutique/get.php?id_module=' + id_module, { headers: authHeader() });
            return res.data;
        }
        catch (err) {
            return false;
        }
    }

    async updateArticlesBoutiqueConfig(articles) {
        if (!articles) return false;
        try {
            await axios.post(API_URL + 'articles_boutique/update_config.php', articles, { headers: authHeader() });
            return true;
        }
        catch (err) {
            return err.response?.data;
        }
    }

    async getConfigHistory(action, id) {

        if (!action || !id) return false;
        try {
            let res = await axios.get(API_URL + 'config_history/get.php?action=' + action + '&id=' + id, { headers: authHeader() });
            return res.data;
        }
        catch (err) {
            return false;
        }
    }
    async uploadReglement(data) {
        if (!data) return false;
        try {
            let res = await axios.post(API_URL + 'module/reglement/upload.php', data, { headers: authHeader() });
            return res.data;
        }
        catch (err) {
            return err.response.data;
        }
    }

    async uploadFlyer(data) {

        if (!data) return false;
        try {
            let res = await axios.post(API_URL + 'module/flyer/upload.php', data, { headers: authHeader() });
            return res.data;
        }
        catch (err) {
            return err.response.data;
        }
    }

    async uploadMailingSystemImage(file, id_event) {

        if (!file) return false;
        const formData = new FormData();
        formData.append('file', file);
        formData.append('id_event', id_event);
        try {
            let res = await axios.post(API_URL + 'mailing_system/images/upload.php', formData, {
                headers: {
                    ...authHeader(),
                    'Content-Type': 'multipart/form-data'
                }
            });
            return res.data;
        }
        catch (err) {
            console.error('Erreur upload image:', err);
            return err.response?.data || { error: 'Erreur lors de l\'upload de l\'image' };
        }
    }

    async getValidationDocumentsPendings(id_module) {
        if (!id_module) return false;
        try {
            let res = await axios.get(API_URL + 'validation_documents/get.php?id_module=' + id_module, { headers: authHeader() });
            return res.data;
        }
        catch (err) {
            return false;
        }
    }
    async getValidationWebservicePendings(id_module) {
        if (!id_module) return false;
        try {
            let res = await axios.get(API_URL + 'validation_webservice/get.php?id_module=' + id_module, { headers: authHeader() });
            return res.data;
        }
        catch (err) {
            return false;
        }
    }
    async getValidationPPSPendings(id_module) {
        if (!id_module) return false;
        try {
            let res = await axios.get(API_URL + 'validation_pps/get.php?id_module=' + id_module, { headers: authHeader() });
            return res.data;
        }
        catch (err) {
            return false;
        }
    }
    async validateWebservice(id_module) {
        if (!id_module) return false;
        try {
            await axios.post(API_URL + 'validation_webservice/run_service.php', { id_module: id_module }, { headers: authHeader() });
            return true;
        }
        catch (err) {
            return err.response.data;
        }
    }

    async validatePPS(id_module) {
        if (!id_module) return false;
        try {
            await axios.post(API_URL + 'validation_pps/run_service.php', { id_module: id_module }, { headers: authHeader() });
            return true;
        }
        catch (err) {
            return err.response.data;
        }
    }
    async validateDocument(inscription) {
        if (!inscription) return false;
        try {
            await axios.post(API_URL + 'validation_documents/post.php', inscription, { headers: authHeader() });
            return true;
        }
        catch (err) {
            return err.response.data;
        }
    }

    async getValidationJustificatifVague(id_module) {
        if (!id_module) return false;
        try {
            let res = await axios.get(API_URL + 'validation_justificatif_vague/get.php?id_module=' + id_module, { headers: authHeader() });
            return res.data;
        }
        catch (err) {
            return false;
        }
    }

    async postValidationJustificatifVague(payload) {
        if (!payload) return false;
        try {
            await axios.post(API_URL + 'validation_justificatif_vague/post.php', payload, { headers: authHeader() });
            return true;
        }
        catch (err) {
            return err.response?.data || false;
        }
    }

    async setCommandeStatus(uuid_commande, status) {
        if (!uuid_commande || !status) return false;
        try {
            await axios.post(API_URL + 'commande/set_status.php', { uuid_commande: uuid_commande, status: status }, { headers: authHeader() });
            return true;
        }
        catch (err) {
            return false;
        }
    }

    async makeRefund(refund) {
        if (!refund) return false;
        try {
            let response = await axios.post(API_URL + 'refund/post.php', refund, { headers: authHeader() });
            return response;
        }
        catch (err) {
            console.log(err);
            return false;
        }
    }

    async validTokenViewAsAdmin(token, base) {
        if (token == null || token == undefined || token == "") return false;
        if (base == null || base == undefined || base == "") return false;
        try {
            let res = await axios.get(API_URL + 'view_as_admin/valid_token.php?token=' + token + "&module=" + base, { headers: authHeader() });
            return res.data;
        }
        catch (err) {
            return false;
        }
    }
    async getTokenViewAsAdmin(base) {
        if (base == null || base == undefined || base == "") return false;
        try {
            let res = await axios.get(API_URL + 'view_as_admin/get_token.php?module=' + base, { headers: authHeader() });
            return res.data;
        }
        catch (err) {
            return false;
        }
    }

    async encryptData(data) {
        if (!data) return false;
        try {
            let res = await axios.get(API_URL + 'encrypt/get.php?data=' + data, { headers: authHeader() });
            return res.data;
        }
        catch (err) {
            return false;
        }
    }

    async getStatistiquesActivites(id_module) {
        if (!id_module) return false;
        try {
            let res = await axios.get(API_URL + 'statistiques/activites/get.php?id_module=' + id_module, { headers: authHeader() });
            return res.data;
        }
        catch (err) {
            return false;
        }
    }
    async getStatistiquesOptions(id_module) {
        if (!id_module) return false;
        try {
            let res = await axios.get(API_URL + 'statistiques/options/get.php?id_module=' + id_module, { headers: authHeader() });
            return res.data;
        }
        catch (err) {
            return false;
        }
    }

    async getStatistiquesInscriptions(id_module) {
        if (!id_module) return false;
        try {
            let res = await axios.get(API_URL + 'statistiques/inscriptions/get.php?id_module=' + id_module, { headers: authHeader() });
            return res.data;
        }
        catch (err) {
            return false;
        }
    }

    async getFinancesOrga(id_module) {
        if (!id_module) return false;
        try {
            let res = await axios.get(API_URL + 'finances/get.php?type=orga&id_module=' + id_module, { headers: authHeader() });
            return res.data;
        }
        catch (err) {
            return false;
        }
    }
    async getFinances(base) {
        if (base == null || base == undefined || base == "") return false;
        try {
            let res = await axios.get(API_URL + 'finances/plateforme/get.php?base_module=' + base, { headers: authHeader() });
            return res.data;
        }
        catch (err) {
            return false;
        }
    }

    async getTeeShirts(id_module) {
        if (!id_module) return false;
        try {
            let res = await axios.get(API_URL + 'teeshirts/get.php?id_module=' + id_module, { headers: authHeader() });
            return res.data;
        }
        catch (err) {
            return false;
        }
    }

    async getPaymentsRequests(inscription) {
        if (!inscription) return false;
        if (!inscription.id_commande || !inscription.id) return false;
        try {
            let res = await axios.get(API_URL + 'payments_requests/get.php?id_commande=' + inscription.id_commande + '&id_inscription=' + inscription.id, { headers: authHeader() });
            return res.data;
        }
        catch (err) {
            return [];
        }
    }

    async createPaymentRequest(request) {
        if (!request) return false;
        try {
            await axios.post(API_URL + 'payment_request/post.php', request, { headers: authHeader() });
            return true;
        }
        catch (err) {
            return false;
        }
    }

    async getCommandeById(id_commande) {
        if (!id_commande) return false;
        try {
            let res = await axios.get(API_URL + 'commande/get.php?id=' + id_commande, { headers: authHeader() });
            return res.data;
        }
        catch (err) {
            return false;
        }
    }

    async sendConfirmationEmail(uuid_commande) {
        if (!uuid_commande) return false;
        try {
            await axios.post(API_URL + 'commande/send_confirmation_email.php', { uuid: uuid_commande }, { headers: authHeader() });
            return true;
        }
        catch (err) {
            return false;
        }
    }

    async generateLoginLink(id_account) {

        if (!id_account) return false;
        try {
            let res = await axios.post(API_URL + 'user_account/generate_login_link.php', { id_utilisateur: id_account }, { headers: authHeader() });
            return res.data;
        }
        catch (err) {
            return false;
        }
    }

    /**
     * Recherche des comptes utilisateur par adresse email
     * @param {string} email - Adresse email à rechercher
     * @param {number} id_module - ID du module
     * @returns {Array<{id: number, email: string}>} | false
     */
    async searchUserAccountsByEmail(email, id_module) {
        if (!email || email.trim().length < 2) return [];
        if (!id_module) return [];
        try {
            let res = await axios.get(API_URL + 'user_account/search.php?email=' + encodeURIComponent(email.trim()) + '&id_module=' + id_module, { headers: authHeader() });
            return res.data || [];
        }
        catch (err) {
            return [];
        }
    }

    /**
     * Réassocie une inscription et sa commande à un compte utilisateur
     * @param {number} id_inscription - ID de l'inscription
     * @param {number} id_commande - ID de la commande
     * @param {number} id_account - ID du compte utilisateur cible
     * @returns {boolean}
     */
    async reassignInscription(id_inscription, id_account) {
        if (!id_inscription || !id_account) return false;
        try {
            await axios.post(API_URL + 'inscription/reassign/post.php', {
                id_inscription: id_inscription,
                id_account: id_account
            }, { headers: authHeader() });
            return true;
        }
        catch (err) {
            return false;
        }
    }

    async generatePaymentLink(uuid) {
        if (!uuid) return false;
        try {
            let res = await axios.post(API_URL + 'commande/generate_payment_link.php', { uuid: uuid }, { headers: authHeader() });
            return res.data;
        }
        catch (err) {
            return false;
        }
    }

    async postCodeReduction(code) {
        if (!code) return false;
        try {
            let res = await axios.post(API_URL + 'code_reduction/post.php', code, { headers: authHeader() });
            return res.data;
        }
        catch (err) {
            return false;
        }
    }

    async removeCodeReduction(id) {
        if (!id) return false;
        try {
            await axios.get(API_URL + 'code_reduction/delete.php?id=' + id, { headers: authHeader() });
            return true;
        }
        catch (err) {
            return false;
        }
    }

    async activateCodeReduction(id) {
        if (!id) return false;
        try {
            await axios.get(API_URL + 'code_reduction/activate.php?id=' + id, { headers: authHeader() });
            return true;
        }
        catch (err) {
            return false;
        }
    }

    async deleteCodeReduction(id) {
        if (!id) return false;
        try {
            await axios.get(API_URL + 'code_reduction/deleteFully.php?id=' + id, { headers: authHeader() });
            return true;
        }
        catch (err) {
            return false;
        }
    }

    async fetchCodesReduction(id_module) {
        if (!id_module) return false;
        try {
            let res = await axios.get(API_URL + 'codes_reduction/get.php?id_module=' + id_module, { headers: authHeader() });
            return res.data;
        }
        catch (err) {
            return false;
        }
    }

    async getHistorique(id_evenement) {
        if (!id_evenement) return false;
        try {
            let res = await axios.get(API_URL + 'historique/get.php?id_evenement=' + id_evenement, { headers: authHeader() });
            return res.data;
        }
        catch (err) {
            return false;
        }
    }

    async getLightInscriptions(id_module, non_valides = 0) {
        if (!id_module) return false;
        try {
            let res = await axios.get(API_URL + 'inscriptions/get_light.php?id_module=' + id_module + '&doc_non_valides=' + non_valides, { headers: authHeader() });
            return res.data.map((x) => {
                x.send = false;
                x.success = false;
                return x;
            });
        }
        catch (err) {
            return false;
        }
    }

    async sendJMinus3Email(id_inscription) {
        if (!id_inscription) return false;
        const data = {
            id_inscription: id_inscription
        }
        try {
            await axios.post(API_URL + 'emails/send_j_minus_3.php', data, { headers: authHeader() });
            return true;
        }
        catch (err) {
            return false;
        }
    }

    async sendEmailInscription(id_inscription) {
        if (!id_inscription) return false;
        const data = {
            id_inscription: id_inscription,
        }
        try {
            await axios.post(API_URL + 'emails/send_inscription_email.php', data, { headers: authHeader() });
            return true;
        }
        catch (err) {
            return false;
        }
    }

    async sendRappelDocumentEmail(id_inscription) {
        if (!id_inscription) return false;
        const data = {
            id_inscription: id_inscription
        }
        try {
            await axios.post(API_URL + 'emails/send_rappel_document.php', data, { headers: authHeader() });
            return true;
        }
        catch (err) {
            return false;
        }
    }

    async getLightInscriptionsAlerteSMS(id_module) {
        if (!id_module) return false;
        try {
            let res = await axios.get(API_URL + 'inscriptions/get_light.php?id_module=' + id_module + '&alerte_sms=1', { headers: authHeader() });
            return res.data.map((x) => {
                x.send = false;
                x.success = false;
                return x;
            });
        }
        catch (err) {
            return false;
        }
    }

    async sendRappelContactSMS(id_inscription) {
        if (!id_inscription) return false;
        const data = {
            id_inscription: id_inscription
        }
        try {
            await axios.post(API_URL + 'emails/send_rappel_contact_sms.php', data, { headers: authHeader() });
            return true;
        }
        catch (err) {
            return false;
        }
    }

    async writeLogs(action, id_module, owner) {
        if (!action || !id_module) return false;
        try {
            await axios.post(API_URL + 'logs/post.php', { action: action, id_module: id_module, owner: owner }, { headers: authHeader() });
            return true;
        }
        catch (err) {
            return false;
        }
    }

    async getLogs(action, id_module) {
        if (!action || !id_module) return false;
        try {
            let res = await axios.get(API_URL + 'logs/get.php?action=' + action + '&id_module=' + id_module, { headers: authHeader() });
            return res.data;
        }
        catch (err) {
            return false;
        }
    }

    async getStatistiquesInscrits(id_module) {
        if (!id_module) return false;
        try {
            let res = await axios.get(API_URL + 'statistiques/inscrits/get.php?id_module=' + id_module, { headers: authHeader() });
            return res.data;
        }
        catch (err) {
            return false;
        }
    }

    async createLienGroupe(lien_groupe, id_module) {
        if (!lien_groupe) return false;
        if (!id_module) return false;
        lien_groupe.id_module = id_module;
        try {
            let res = await axios.post(API_URL + 'lien_groupe/post.php', lien_groupe, { headers: authHeader() });
            return res.data;
        }

        catch (err) {
            return false;
        }
    }

    async getLiensGroupe(id_module) {
        if (!id_module) return false;
        try {
            let res = await axios.get(API_URL + 'liens_groupe/get.php?id_module=' + id_module, { headers: authHeader() });
            return res.data;
        }

        catch (err) {
            return false;
        }
    }

    async getLienGroupe(token, id_module) {
        if (!token || !id_module) return false;
        try {
            let res = await axios.get(API_URL + 'lien_groupe/get.php?token=' + encodeURIComponent(token) + '&id_module=' + id_module, { headers: authHeader() });
            return res.data;
        }
        catch (err) {
            return err.response?.data || false;
        }
    }

    async updateLienGroupe(lien_groupe) {
        if (!lien_groupe) return false;
        try {
            let res = await axios.post(API_URL + 'lien_groupe/update.php', lien_groupe, { headers: authHeader() });
            return res.data;
        }
        catch (err) {
            return err.response?.data || false;
        }
    }

    async setLienGroupeStatus(id_groupe, disable) {
        if (!id_groupe || disable === undefined || disable === null) return false;
        try {
            let res = await axios.post(API_URL + 'lien_groupe/set_status.php', { id_groupe: id_groupe, disable: disable }, { headers: authHeader() });
            return res.data;
        }

        catch (err) {
            return false;
        }
    }

    /**
     * Met à jour la limite d'inscriptions (max_inscrits) d'un lien de groupe. 0 = pas de limite.
     * @param {number|string} id_groupe
     * @param {number|string} max_inscrits
     * @returns {object|false}
     */
    async updateLienGroupeMaxInscrits(id_groupe, max_inscrits) {
        if (!id_groupe) return false;
        if (max_inscrits === undefined || max_inscrits === null || max_inscrits === '') return false;
        try {
            let res = await axios.post(API_URL + 'lien_groupe/update_max_inscrits.php', {
                id_groupe: id_groupe,
                max_inscrits: max_inscrits,
            }, { headers: authHeader() });
            return res.data;
        }
        catch (err) {
            return err.response?.data || false;
        }
    }

    async sendLienGroupeNotification(id_groupe) {
        if (!id_groupe) return false;
        try {
            let res = await axios.post(API_URL + 'lien_groupe/send_notification.php', {
                id_groupe: id_groupe,
            }, { headers: authHeader() });
            return res.data;
        }
        catch (err) {
            return err.response?.data || false;
        }
    }

    async closeLienGroupe(id_groupe, closureData) {
        if (!id_groupe || !closureData) return false;
        try {
            let res = await axios.post(API_URL + 'lien_groupe/close/post.php', { id_groupe: id_groupe, ...closureData }, { headers: authHeader() });
            return res.data;
        }
        catch (err) {
            return false;
        }
    }

    async getPreInscriptions(params) {

        try {
            let res = await axios.get(API_URL + 'pre_inscriptions/get.php?' + params);
            return res.data;
        }

        catch (err) {
            return false;
        }
    }

    async getPreInscriptionsForValidation(filters, with_nb_inscrits, id_module) {
        if (!filters) return false;
        filters = filters.map(filter => {
            return {
                name: filter.name,
                type: filter.type,
                value: filter.value
            }
        });
        const data = {
            filters: filters,
            with_nb_inscrits: with_nb_inscrits,
            id_module: id_module
        }
        try {
            let res = await axios.post(API_URL + 'pre_inscriptions/validation/get.php', data, { headers: authHeader() });
            return res.data;
        }
        catch (err) {
            return false;
        }
    }

    async getPreInscriptionsMaxiRace(filters, with_nb_inscrits, id_module) {
        if (!filters) return false;
        // keep only name,type and value
        filters = filters.map(filter => {
            return {
                name: filter.name,
                type: filter.type,
                value: filter.value
            }
        });
        const data = {
            filters: filters,
            with_nb_inscrits: with_nb_inscrits,
            id_module: id_module
        }
        try {
            let res = await axios.post(API_URL + 'pre_inscriptions/MAXIRACE/get.php', data, { headers: authHeader() });
            return res.data;
        }
        catch (err) {
            return false;
        }
    }

    async getInscriptionsByGroupe(id_groupe) {
        if (!id_groupe) return false;
        try {
            let res = await axios.get(API_URL + 'pre_inscriptions/get_by_groupe.php?id_groupe=' + id_groupe, { headers: authHeader() });
            return res.data;
        }
        catch (err) {
            return false;
        }
    }

    async markFlaggedAsValidated(ids_commande) {
        if (!ids_commande) return false;
        try {
            let res = await axios.post(API_URL + 'pre_inscriptions/mark_flagged_as_validated.php', { ids_commande: ids_commande }, { headers: authHeader() });
            return res.data;
        }
        catch (err) {
            return false;
        }
    }

    async getPendingsCommandes(id_module) {
        if (!id_module) return false;
        try {
            let res = await axios.get(API_URL + 'pre_inscriptions/commandes/get_pendings.php?id_module=' + id_module, { headers: authHeader() });
            return res.data;
        }
        catch (err) {
            return false;
        }
    }

    async getUnpaidPendingsCommandes(id_module) {
        if (!id_module) return false;
        try {
            let res = await axios.get(API_URL + 'pre_inscriptions/commandes/get_unpaid.php?id_module=' + id_module, { headers: authHeader() });
            return res.data;
        }
        catch (err) {
            return false;
        }
    }

    async sendFailedChargeEmail(id) {
        if (!id) return false;
        try {
            let res = await axios.get(API_URL + 'pre_inscriptions/commandes/send_failed_email.php?id=' + id, { headers: authHeader() });
            if (res.data.code == 200) {
                return res.data.message;
            }
            return false;
        }
        catch (err) {
            return false;
        }
    }

    async chargeCommande(id_commande) {
        if (!id_commande) return false;
        try {
            let res = await axios.get(API_URL + 'pre_inscriptions/commande/charge.php?id_commande=' + id_commande, { headers: authHeader() });
            if (res.data.code == 200) {
                if (res.data.message) {
                    return res.data.message;
                }
                if (res.data.error) {
                    return res.data.error;
                }
            }
            return "ERREUR INCONNUE";
        }
        catch (err) {
            return "ERREUR INCONNUE";
        }
    }

    async FetchMailingSystemFilteredInscriptionsList(filters, id_module) {
        if (!filters) return false;
        const data = {
            filters: filters,
            id_module: id_module
        }
        try {
            let res = await axios.post(API_URL + 'mailing_system/filtered_inscriptions/get.php', data, { headers: authHeader() });
            return res.data;
        }
        catch (err) {
            return false;
        }
    }

    async CreateMailingSystemList(listName, contacts, id_module) {
        if (!listName) return false;
        if (!contacts) return false;
        if (!id_module) return false;
        const data = {
            listName: listName,
            contacts: contacts,
            id_module: id_module
        }
        try {
            let res = await axios.post(API_URL + 'mailing_system/contacts_list/post.php', data, { headers: authHeader() });
            return res.data;
        }
        catch (err) {
            return false;
        }
    }

    async fetchAllContactsLists(id_module) {
        if (!id_module) return false;
        try {
            let res = await axios.get(API_URL + 'mailing_system/contacts_lists/get.php?id_module=' + id_module, { headers: authHeader() });
            return res.data;
        }
        catch (err) {
            return false;
        }
    }

    async getInscriptions(params) {
        try {
            let res = await axios.get(API_URL + 'inscriptions/get.php?' + params, { headers: authHeader() });
            return res.data;
        }
        catch (err) {
            return false;
        }
    }

    async getListInscriptionsBulkRefunds(id_module) {
        if (!id_module) return false;
        try {
            let res = await axios.get(API_URL + 'bulk_refunds/get_list_inscriptions.php?id_module=' + id_module, { headers: authHeader() });
            return res.data;
        }
        catch (err) {
            return false;
        }
    }

    async searchListeAttenteParticipant(mail, id_module) {
        if (!mail) return false;
        if (!id_module) return false;
        let data = {
            mail: mail,
            id_module: id_module
        }
        try {
            let res = await axios.post(API_URL + 'liste_attente/search.php', data, { headers: authHeader() });
            return res.data;
        }
        catch (err) {
            return false;
        }
    }

    async getOverviewListeAttenteBourse(id_module) {
        if (!id_module) return false;
        try {
            let res = await axios.get(API_URL + 'liste_attente/overview.php?id_module=' + id_module, { headers: authHeader() });
            return res.data;
        }
        catch (err) {
            return false;
        }
    }

    async deleteFromListeAttenteBourse(id_liste_attente) {
        if (!id_liste_attente) return false;
        let data = {
            id: id_liste_attente
        }
        try {
            let res = await axios.post(API_URL + 'liste_attente/delete.php', data, { headers: authHeader() });
            return res.data;
        }
        catch (err) {
            return false;
        }
    }

    async getHistoryInscription(id_inscription) {
        if (!id_inscription) return false;
        try {
            let res = await axios.get(API_URL + 'inscription/history/get.php?id_inscription=' + id_inscription, { headers: authHeader() });
            return res.data;
        }
        catch (err) {
            return false;
        }
    }

    async getPodiumsTemplate(filters) {
        if (!filters) return false;
        try {
            let res = await axios.post(API_URL + 'podiums/template/get.php', filters, { headers: authHeader() });
            return res.data;
        }
        catch (err) {
            return false;
        }
    }
    async exportPodiumsTemplate(params) {
        if (!params) return false;
        try {
            let res = await axios.post(API_URL + 'podiums/template/export.php', params, {
                headers: authHeader(),
                responseType: 'blob'
            });
            return res.data;
        }
        catch (err) {
            return false;
        }
    }

    /**
     * Groupes / équipes NFL26 avec leurs inscriptions.
     * @param {number|string} id_module
     * @returns {{ groupes: Array<{ nom_groupe: string, nb_inscrits: number, inscriptions: Array<{ id_inscription: number, nom: string, prenom: string, course: string, via_lien_groupe: boolean, nom_equipe?: string }> }> }|false}
     */
    async getNfl26Equipes(id_module) {
        if (!id_module) return false;
        try {
            let res = await axios.get(API_URL + 'nfl26/equipes/get.php?id_module=' + id_module, { headers: authHeader() });
            return res.data;
        }
        catch (err) {
            return false;
        }
    }

    /**
     * Export PDF des inscrits d'un groupe / équipe NFL26.
     * @param {{ id_module: number|string, nom_groupe: string, inscriptions: Array<{ id_inscription: number, via_lien_groupe: boolean }>, sort_by?: string }} payload
     */
    async exportNfl26EquipePdf(payload) {
        if (!payload?.id_module || !payload?.nom_groupe || !Array.isArray(payload.inscriptions) || payload.inscriptions.length === 0) return false;
        try {
            let res = await axios.post(API_URL + 'nfl26/equipes/export_pdf.php', payload, {
                headers: authHeader(),
                responseType: 'blob'
            });
            return res.data;
        }
        catch (err) {
            return false;
        }
    }

    /**
     * Liste des équipes du module (inscriptions regroupées, commandes associées).
     * @param {number|string} id_module
     * @returns {{ equipes: Array }|false}
     */
    async getEquipesModule(id_module, with_auto_assign_chef_equipe = "0") {
        if (!id_module) return false;

        try {
            let res = await axios.get(API_URL + 'equipes/list.php?id_module=' + id_module + '&with_auto_assign_chef_equipe=' + with_auto_assign_chef_equipe, { headers: authHeader() });
            return res.data;
        }
        catch (err) {
            return false;
        }
    }

    /**
     * Renomme une équipe entière (toutes les inscriptions du groupe).
     * @param {{ id_module: number|string, old_nom_equipe: string, nouveau_nom_equipe: string, ids_inscriptions: string }} payload
     */
    async renameEquipeGroupe(payload) {
        if (!payload?.id_module || !payload.ids_inscriptions || !payload.nouveau_nom_equipe || !payload.old_nom_equipe) return false;
        try {
            let res = await axios.post(API_URL + 'equipes/rename_groupe.php', payload, { headers: authHeader() });
            return res.data;
        }
        catch (err) {
            return err.response?.data ?? false;
        }
    }

    /**
     * Change le nom d'équipe pour une inscription (changement d'équipe pour un participant).
     * @param {{ id_module: number|string, id_inscription: number|string, nouveau_nom_equipe: string }} payload
     */
    async setEquipeNomInscription(payload) {
        if (!payload?.id_module || !payload.id_inscription || !payload.nouveau_nom_equipe) return false;
        try {
            let res = await axios.post(API_URL + 'equipes/rename_inscription.php', payload, { headers: authHeader() });
            return res.data;
        }
        catch (err) {
            return err.response?.data ?? false;
        }
    }

    /**
     * Définit l'inscription comme chef d'équipe. Transmettre id_ancien_chef_inscription pour désigner l'ancien chef.
     * @param {{ id_module: number|string, id_inscription: number|string, id_ancien_chef_inscription?: number|string|null }} payload
     */
    async setChefEquipe(payload) {
        if (!payload?.id_module || payload.id_inscription === undefined || payload.id_inscription === null) return false;
        try {
            const body = {
                id_module: payload.id_module,
                id_inscription: payload.id_inscription,
            };
            if (payload.id_ancien_chef_inscription !== undefined && payload.id_ancien_chef_inscription !== null && payload.id_ancien_chef_inscription !== '') {
                body.id_ancien_chef_inscription = payload.id_ancien_chef_inscription;
            }
            let res = await axios.post(API_URL + 'equipes/set_chef_equipe.php', body, { headers: authHeader() });
            return res.data;
        }
        catch (err) {
            return err.response?.data ?? false;
        }
    }

    /**
     * Crée un créneau de retrait de dossard (admin).
     * @param {{ id_module: number|string, id_course: number|string, nom: string, capacity: number, is_open?: number }} payload
     */
    async postCreneauRetraitDossard(payload) {
        if (!payload?.id_module || payload.id_course === undefined || payload.id_course === null || payload.id_course === '') return false;
        try {
            let res = await axios.post(API_URL + 'creneaux_retrait_dossard/post.php', payload, { headers: authHeader() });
            return res.data;
        }
        catch (err) {
            return err.response?.data ?? false;
        }
    }

    /**
     * Met à jour un créneau (capacité, ouvert/fermé).
     * @param {{ id: number|string, capacity?: number, is_open?: number }} payload
     */
    async updateCreneauRetraitDossard(payload) {
        if (!payload?.id) return false;
        try {
            let res = await axios.post(API_URL + 'creneaux_retrait_dossard/update.php', payload, { headers: authHeader() });
            return res.data;
        }
        catch (err) {
            return err.response?.data ?? false;
        }
    }

    /**
     * Liste des configs du dashboard admin pour un module.
     * @param {number|string} id_module
     * @returns {Array|{id: number, id_module: number, name: string}[]|false}
     */
    async getDashboardConfig(id_module) {
        if (!id_module) return false;
        try {
            let res = await axios.get(API_URL + 'dashboard_config/get.php?id_module=' + id_module, { headers: authHeader() });
            return res.data;
        }
        catch (err) {
            return false;
        }
    }

    /**
     * Ajoute une variable de config dashboard (ex. HIDE_CODE_PROMO).
     * @param {{ id_module: number|string, name: string }} payload
     */
    async addDashboardConfig(payload) {
        if (!payload?.id_module || !payload?.name) return false;
        try {
            let res = await axios.post(API_URL + 'dashboard_config/post.php', payload, { headers: authHeader() });
            return res.data;
        }
        catch (err) {
            return err.response?.data ?? false;
        }
    }

    /**
     * Supprime une variable de config dashboard.
     * @param {number|string} id
     */
    async deleteDashboardConfig(id) {
        if (!id) return false;
        try {
            let res = await axios.get(API_URL + 'dashboard_config/delete.php?id=' + id, { headers: authHeader() });
            return res.data;
        }
        catch (err) {
            return false;
        }
    }

}
export default new AdminService();